const GlobalConfig = {
  baseUrl: process.env.VUE_APP_BASE_URL,
  FB_LOGIN_APP_2TI_ID: process.env.VUE_APP_IS_PRODUCTION ? "683312195062841" : "1185877244806331",
  FB_LOGIN_APP_BLOVLY_ID: process.env.VUE_APP_IS_PRODUCTION ? "522485165164316" : "1185877244806331",
  GOOGLE_LOGIN_APP_2TI_ID: "372999955642-vpmmtcb4dvaue6bdgk8ue8jicgvlj1rt.apps.googleusercontent.com",
  GOOGLE_LOGIN_APP_BLOVLY_ID: "372999955642-ffkjjfl65kfau8vdj8t65fcdohhp2c1b.apps.googleusercontent.com",
};
export default GlobalConfig;
